













import { Component, Prop, Vue } from "vue-property-decorator";

import Repository from "./Repository.vue";

@Component({ components: { Repository } })
export default class extends Vue {
  @Prop(Date)
  private date: Date;
  @Prop(Array)
  private repositories: object[];

  private get formattedDate(): string {
    const date = this.date.toLocaleDateString();

    return date === new Date().toLocaleDateString() ? "Today" : date;
  }
}
